import axios from "axios";
import { formatDate } from "utils/date";
import { buildDseQuery, buildQuery } from "utils/queryUtils";

export const findEmailLogs = (headers, params) => {
    const val = {
        first: params.first,
        rows: params.rows,
        page: params.page,
        sortField: params.sortField,
        sortOrder: params.sortOrder,
        filters: {
            email: { ...params.filters.email },
            status: { ...params.filters.status },
        },
    };
    let query = buildDseQuery(val, [""]);

    if (params.filters.fromDate.value) {
        query += `${val.filters.email.value || val.filters.status.value ? ";" : ""}createdDate=ge=${formatDate(params.filters.fromDate.value)}`;
    }
    if (params.filters.toDate.value) {
        const toDateVal = new Date(new Date(params?.filters.toDate.value).setDate(new Date(params?.filters.toDate.value).getDate() + 1));
        query += `;createdDate=le=${formatDate(toDateVal)}`;
    }

    return axios.get(`${process.env.REACT_APP_ACM_API_URL}/email-logs${query}`, {
        headers,
    });
};
